/*
* Report page
*/

import * as React from 'react';
import * as _ from 'lodash';

import * as ReportComponents from '../report-components';
import { getSpecialAssessmentPresentation } from '../special-assessments-presentation';

const RSN = ReportComponents.ReportSectionNames;

export const tocConfiguration = [
    {
        title: 'Introduction',
        items: [
            RSN.executiveSummary,
            RSN.introduction,
            RSN.faq,
        ]
    },
    {
        title: 'Reserve Analysis',
        items: [
            RSN.fundingSummary,
            RSN.specialAssessments,
            RSN.percentFundedGraph,
            RSN.componentFundingInformation,
            RSN.yearlySummary,
            RSN.yearlySummaryCurrent,
            RSN.yearlySummaryMinimum,
            RSN.reserveContributionsGraph,
            RSN.significantComponents,
            RSN.significantComponentsGraph,
            RSN.yearlyCashFlow,
            RSN.yearlyReserveExpendituresGraph,
            RSN.projectedReserveExpenditures,
        ],
    },
    {
        title: 'Component Evaluation',
        items: [
            RSN.componentEvaluation,
        ]
    },
    {
        title: 'Glossary of Commonly used Words and Phrases',
        items: [
            RSN.glossary
        ]
    }
];

export const Render = ({ registerFunc, refFunc, scrollToFunc, sectionPages, pageTitle = '', className = '', pageConfiguration, pageCount, reportData, ...rest }) => {
    const sectionName = ReportComponents.ReportSectionNames.tableOfContents;
    const ReportPageWithRegister = ReportComponents.withPageRegistration(ReportComponents.ReportPageHeaderFooter, sectionName, registerFunc, refFunc, scrollToFunc, true);

    const getFirstPageOfSection = (secName: string): any => _(sectionPages).sortBy('pageNumber').find(['sectionName', secName]);
    const getPageNum = (secName: string) => _.get(getFirstPageOfSection(secName), 'pageNumber');

    const TOCSection = ({ section, ...tocSectionRest }) => {
        const links = _.get(section, 'items', [])
            .map((item, itemInd) => (
                <TOCSectionLink key={`tocsectionlink-${item}`} item={item} />
            ));

        return (
            <ReportComponents.ContentsSection title={_.get(section, 'title', '')}>
                {links}
            </ReportComponents.ContentsSection>
        );
    };

    const TOCSectionLink = ({ item, ...tocSectionLinkRest }) => (
        <ReportComponents.ContentsItem
            title={_.get(ReportComponents.ReportSectionTitles, item, '')}
            pageNum={getPageNum(item)}
            clickHandler={(e) => { if (scrollToFunc) { scrollToFunc(e, item); } }}
        />
    );

    let tocConfig = (reportData.showComponentEvaluation) ? tocConfiguration : _.reject(tocConfiguration, { title: 'Component Evaluation' });

    let tocReserveAnalysis = _.find(tocConfig, ['title', 'Reserve Analysis']);
    if (tocReserveAnalysis) {
        if (!reportData.showYearlySummaryCurrent) {
            tocReserveAnalysis.items = _.without(tocReserveAnalysis.items, RSN.yearlySummaryCurrent);
        }

        if (!reportData.showYearlySummaryMinimum) {
            tocReserveAnalysis.items = _.without(tocReserveAnalysis.items, RSN.yearlySummaryMinimum);
        }
    }

    if (tocReserveAnalysis && getSpecialAssessmentPresentation(_.get(reportData, 'specialAssessmentRows', [])).showInline) {
        tocReserveAnalysis.items = _.without(tocReserveAnalysis.items, RSN.specialAssessments);
    }

    const tocSections = tocConfig.map((section, sectionInd) => <TOCSection key={`tocsection-${section.title}`} section={section} />);

    return (
        <div>
            <ReportPageWithRegister className={className} title={pageTitle} pageNum={0} totalPageCount={pageCount} footerData={reportData} showFooter={false}>
                {tocSections}
            </ReportPageWithRegister>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/report/pdf/pages/report-page-table-of-contents.tsx